import { AxiosInstance } from 'axios';
import {
  TutorialVideo,
  TutorialVideoResponse,
  TutorialVideos,
  TutorialVideosParams,
} from './interfaces/portal';

export class PortalAPI {
  constructor(public readonly http: AxiosInstance) {}

  tutorialVideos = {
    list: async (
      params: TutorialVideosParams = {}
    ): Promise<TutorialVideos> => {
      const { page = 1, pageSize = 10 } = params;

      // Construir parâmetros de query para o Strapi
      const queryParams: Record<string, any> = {
        'pagination[page]': page,
        'pagination[pageSize]': pageSize,
      };

      const response = await this._makeRequest<{
        data: TutorialVideoResponse[];
        meta: {
          pagination: {
            page: number;
            pageSize: number;
            pageCount: number;
            total: number;
          };
        };
      }>({
        endpoint: '/api/tutoriais',
        method: 'GET',
        params: queryParams,
      });

      const videos: TutorialVideo[] = response.data.map(
        (item: TutorialVideoResponse) => {
          const url = item.attributes.url;
          const youtubeId = url.match(/embed\/([\w-]+)/)?.[1];
          const thumbnailUrl = youtubeId
            ? `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`
            : undefined;

          return {
            id: item.id,
            enabled: item.attributes.Ativo,
            title: item.attributes.Titulo,
            description: item.attributes.Descricao,
            duration: item.attributes.duracao,
            category: item.attributes.categoria,
            url,
            thumbnailUrl,
          };
        }
      );

      // Extrair categorias apenas dos vídeos encontrados
      const foundCategories = videos.map((video) => video.category);
      const uniqueCategories = ['Todos', ...new Set(foundCategories)];

      return {
        videos,
        categories: uniqueCategories,
        pagination: {
          page: response.meta.pagination.page,
          pageSize: response.meta.pagination.pageSize,
          pageCount: response.meta.pagination.pageCount,
          total: response.meta.pagination.total,
        },
      };
    },
  };

  private async _makeRequest<T>({
    endpoint,
    method,
    body = null,
    params = null,
    headers = null,
    safe = false,
    config = null,
  }: Params): Promise<T> {
    try {
      const { data } = await this.http({
        method: method,
        url: endpoint,
        ...(body && { data: body }),
        ...(params && { params }),
        ...(headers && { headers }),
        ...(config && { ...config }),
      });
      if (data === '') return null as T;

      return data;
    } catch (error: any) {
      const requestError = {
        url: error.config.url,
        method: error.config.method,
        status: error.response?.status,
        data: error.response?.data,
      };

      console.error('Error API:', error?.request?._header, requestError);

      if (safe) return null as T;
      if (error.response?.data)
        throw {
          ...error.response?.data,
          data: error?.response?.data,
          status: error.response.status,
        };

      throw error;
    }
  }
}

interface Params {
  endpoint: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  body?: any;
  params?: any;
  headers?: any;
  safe?: boolean; // Se true, o método não irá lançar exceção caso não encontre cotação para o ativo, retornando null
  config?: any;
}
